import type { InstallExceptionDisposition } from "@shared/install-exception";

export interface ReviewInstallException {
    disposition: InstallExceptionDisposition;
    reasonCode: string;
    reasonLabel: string;
    note: string | null;
    recordedAt: string | null;
}

export function installExceptionDispositionText(disposition: InstallExceptionDisposition): string {
    switch (disposition) {
        case "left_with_manager":
            return "POS left with the store manager. Counts as installed (unconfirmed); a possible removal is created next cycle.";
        case "removed_from_store":
            return "POS removed from the store. Counts as not installed; no removal next cycle.";
        default: {
            const unreachable: never = disposition;
            return unreachable;
        }
    }
}

export function InstallExceptionPanel({ installException }: { installException: ReviewInstallException | null | undefined }) {
    if (!installException) return null;
    return (
        <div
            className="rounded-md border border-red-200 bg-red-50/40 p-4 text-sm"
            data-testid="install-exception-panel"
        >
            <div className="text-xs font-bold uppercase tracking-wider text-red-800">Install not possible</div>
            <div className="mt-1 font-medium text-foreground">{installException.reasonLabel}</div>
            {installException.note ? (
                <div className="mt-1 italic text-muted-foreground">{installException.note}</div>
            ) : null}
            <div className="mt-2 text-muted-foreground">{installExceptionDispositionText(installException.disposition)}</div>
        </div>
    );
}
